import { render } from "./VatExchangeRateTable.vue?vue&type=template&id=9f16250e"
import script from "./VatExchangeRateTable.vue?vue&type=script&lang=js"
export * from "./VatExchangeRateTable.vue?vue&type=script&lang=js"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__